import { ChatMessageAuthorType } from 'enums/modules/chat/chatMessageAuthorType';
import { ChatMessageStatus } from 'enums/modules/chat/chatMessageStatus';
import { ChatMessage, ChatMessageList } from 'model/modules/chat/chatMessage';
import mapPaginationListFromApi from 'rtkQuery/sharespro/mapper/shared/mapPaginationListFromApi';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import mapAuthorDataFromApi from './mapAuthorDataFromApi';

export const mapChatMessageListItemFromApi = (
  apiItem: ApiChatMessage
): ChatMessage => ({
  id: apiItem.id,
  authorData:
    apiItem.author_data !== null
      ? mapAuthorDataFromApi(apiItem.author_data)
      : null,
  authorType: apiItem.author as ChatMessageAuthorType,
  managerName: apiItem.manager_name,
  text: apiItem.content,
  createdAt: new Date(apiItem.create_timestamp * 1000),
  viewedAt: apiItem.view_timestamp
    ? new Date(apiItem.view_timestamp * 1000)
    : null,
  updated: apiItem.updated ?? false,
  chatId: apiItem.chat_id ?? -1,
  sendingId: '',
  files: apiItem.files ?? [],
  status: apiItem.view_timestamp
    ? ChatMessageStatus.Read
    : ChatMessageStatus.Sent,
});

export const mapChatMessageListFromApi = (
  resp: SharesproApiResponse<ApiListResponse<ApiChatMessage>>
): RemoteList<ChatMessage> => {
  return {
    items: resp.data.items.map(mapChatMessageListItemFromApi),
  };
};

const mapChatMessagePaginationListFromApi = (
  resp: SharesproApiResponse<ApiPaginationListResponse<ApiChatMessage>>,
  chatId: ID
): ChatMessageList => {
  return {
    ...mapPaginationListFromApi<ChatMessage, ApiChatMessage>(
      resp.data,
      mapChatMessageListItemFromApi
    ),
    chatId,
  };
};

export default mapChatMessagePaginationListFromApi;
